// extracted by css-extract-rspack-plugin
export default {"ButtonLink":"ExternalLink-module__ButtonLink___p8cDj","LinkRoot":"ExternalLink-module__LinkRoot___dXTXK"};